'use client'
import { createContext } from 'react'

import { Locale } from '@/i18n'

export type Dictionary = Record<string, string>

export const I18nContext = createContext<{ locale: Locale; dictionary: Dictionary }>({
  locale: 'en',
  dictionary: {},
})
